import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import PactometroCheck from './checks';
import PactometroBarrasSimple from './barrasSimple';
import './index.scss';

const PactometroCheckSimple = ({ seatData, totalSeat }) => {
  const [selectedsId, setSelectedsId] = useState([]);
  const filterData = seatData.filter(current => current.seats >= 1);
  const { totalVotes } = filterData.reduce(
    (tot, current) => {
      tot.totalVotes += current.votes;
      tot.totalSeat += current.seats;
      return tot;
    },
    { totalVotes: 0, totalSeat: 0 }
  );
  return (
    <div className="containerPactometro containerPactometroSimple">
      <div className="content-pactos-barras content-pactos-barrasSimple">
        <PactometroBarrasSimple
          data={filterData}
          selecteds={selectedsId}
          totalSeat={totalSeat}
          totalVotes={totalVotes}
        />
      </div>
      <div className="content-pactos content-pactosSimple">
        <p className="legend">
          *Pincha sobre cada partido para sumar sus escaños
        </p>
        <PactometroCheck
          data={filterData}
          selecteds={selectedsId}
          onChange={setSelectedsId}
        />
      </div>
    </div>
  );
};

PactometroCheckSimple.propTypes = {
  seatData: PropTypes.arrayOf(
    PropTypes.shape({
      partyAcronym: PropTypes.string.isRequired,
      seats: PropTypes.number.isRequired,
      votesPercent: PropTypes.number.isRequired,
      votes: PropTypes.number.isRequired,
      id: PropTypes.number.isRequired
    })
  ).isRequired
};

export default PactometroCheckSimple;
